import '../../scripts/common';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import AskQuestion from '../../components/AskQuestion';
import CustomersPage from '../../components/CustomersPage';

import './styles.css';
import './getForm';

$(() => {
    Header.create();
    Footer.create();
    CustomersPage.create();
    AskQuestion.create();
});
